import CustomerStoryHorizontal from "@components/BasicComponents/Cards/CustomerStory/CustomerStoryHorizontal"
import SwiperT from "@components/BasicComponents/Swiper/MySwiper"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import {
	AdvancedSideAssetModuleType,
	CustomerStoryModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"
import {SwiperSlide} from "swiper/react"

import styles from "./PinnedStories.module.scss"
type Props = {
	stories: CustomerStoryModuleType[]
	data: AdvancedSideAssetModuleType
}

const PinnedStories = (props: Props) => {
	return (
		<section>
			<ContainerWrapper style={{overflow: "hidden"}}>
				<Separator size={128}>
					<div className={styles.title}>
						<Title
							content={props.data.sectionTitle}
							size={"XL"}
							center
						/>
					</div>
					<Separator size={64} />
					<SwiperT
						className={"SwiperCustomer"}
						module={props.stories.map(
							(
								element: CustomerStoryModuleType,
								index: number,
							) => {
								if (index < 3) {
									return (
										<React.Fragment key={index}>
											<SwiperSlide key={index}>
												<CustomerStoryHorizontal
													className={
														styles.cardContainer
													}
													data={element}
												/>
											</SwiperSlide>
										</React.Fragment>
									)
								}
								return undefined
							},
						)}
						spaceBetween={200}
					/>
					<Separator id={"startOfPagination"} size={32} />
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default PinnedStories
